import QueryStringSetPlaceOrder from "@affinity/Handlers/QueryStringSetPlaceOrder";
import { customDispatch } from "@affinity/Store/ServiceBase";
import { AffinityDelivery, AffinityProduct, ProductModelX } from "@affinity/Store/StoreTypes";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

// External parameters
export interface SetQuoteMainDetailsParameters {
    quantity: number,
    selectedDelivery: AffinityDelivery,
    postcode: string,
    product: AffinityProduct,
}

// Internal parameters
interface Props {
}

type HandlerType = Handler<SetQuoteMainDetailsParameters, Props>;

const UpdateState: HandlerType = props => {
    (props.dispatch as customDispatch)({
        type: "Affinity/GetQuote/Quotation/Set",
        quantity: props.parameter.quantity,
        selectedDelivery: props.parameter.selectedDelivery,
    });
}

const UpdateQueryString: HandlerType = props => {
    props.dispatch(QueryStringSetPlaceOrder({
        quantity: props.parameter.quantity,
        product: props.parameter.product === AffinityProduct.Regular ? "regular" : "premium",
        postcode: props.parameter.postcode,
        page: "placeorder"
    }));
}

const Tracking: HandlerType = props => {
    //
}

const chain = [
    UpdateState,
    UpdateQueryString,
    Tracking,
];

const createAccount = createHandlerChainRunner(chain, "SetQuoteMainDetails");
export default createAccount;